import ReactTooltip from "react-tooltip";

export const saveLinkages = ({
  selectedData,
  machine_name,
  formApi,
  saveRowIndex,
  toFieldArray,
}) => {
  const formValues = formApi.getState().values;
  const masterFieldValues = formValues[toFieldArray];

  if (typeof selectedData === "string") {
    selectedData = [selectedData];
  }

  // Always sort alphanumerically before saving
  selectedData.sort((a, b) => a.localeCompare(b, "en", { numeric: true }));

  if (saveRowIndex !== undefined && toFieldArray) {
    // Update specified row inside master array
    masterFieldValues[saveRowIndex][machine_name] = selectedData;
    // Save to form
    formApi?.change(toFieldArray, masterFieldValues);
  } else {
    // Save to editing field
    formApi?.change(`add_values_field[0][${machine_name}]`, selectedData);
  }
};

export const renderTextCell = ({ value, id, index }) => {
  const tooltipId = `${id}_${index}`;
  return (
    <>
      <span data-tip data-for={tooltipId}>
        {value || "--"}
      </span>
      <ReactTooltip type="dark" effect="solid" id={`${tooltipId}`}>
        <span>{value || "--"}</span>
      </ReactTooltip>
    </>
  );
};
